import {
  gsap
} from 'gsap';

export default () => {
  // Find all text with .animatedText class and break each letter into a span
  var animatedText = document.getElementsByClassName('animatedText');
  for (var i = 0; i < animatedText.length; i++) {
    var wordWrap = animatedText.item(i);
    wordWrap.innerHTML = wordWrap.innerHTML.replace(
      /(^|<\/?[^>]+>|\s+)([^\s<]+)/g,
      '$1<span class="animatedText-item"><span class="animatedText-word">$2</span></span>'
    );
  }

  var tl = gsap.timeline();

  tl.from('.animatedText-word', {
    ease: 'Expo.easeOut',
    duration: 1,
    yPercent: 125,
    stagger: 0.05,
    delay: 0.5,
  });

  tl.from(
    '.fade-in', {
      ease: 'Expo.easeOut',
      duration: 1,
      opacity: 0,
      stagger: 0.10,
    },
    '-=0.5'
  );
};
